var _style, _path, _ellipse, _ellipse2, _g, _ellipse3, _ellipse4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 248 248",
    style: {
      enableBackground: "new 0 0 248 248"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.8;fill:url(#SVGID_1_);}\n\t.st1{fill:#CD1641;stroke:#FF2C68;stroke-miterlimit:10;}\n\t.st2{fill:#CD1641;}\n\t.st3{opacity:0.3;fill:#CD1641;}\n\t.st4{opacity:0.79;fill:none;stroke:#C81C47;stroke-miterlimit:10;}\n\t.st5{opacity:0.51;fill:none;stroke:#C81C47;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#00A6FF;stroke-width:24.0383;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st7{fill:url(#SVGID_2_);}\n\t.st8{fill:#091726;}\n\t.st9{opacity:0.72;fill:url(#SVGID_3_);}\n\t.st10{opacity:0.58;fill:url(#SVGID_4_);}\n\t.st11{fill:url(#SVGID_5_);}\n\t.st12{fill:#31CDF3;}\n\t.st13{fill:#6CE1F5;}\n\t.st14{opacity:0.4;fill:url(#SVGID_6_);}\n\t.st15{fill:none;stroke:#F545BD;stroke-width:24.0383;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st16{fill:url(#SVGID_7_);}\n\t.st17{fill:url(#SVGID_8_);}\n\t.st18{fill:#FFFFFF;}\n\t.st19{opacity:0.3;fill:url(#SVGID_9_);}\n\t.st20{opacity:0.4;fill:none;stroke:#33FFF5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st21{opacity:0.6;fill:none;stroke:#33FFF5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st22{opacity:0.1;fill:none;stroke:#33FFF5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st23{opacity:0.3;fill:url(#SVGID_10_);}\n\t.st24{opacity:0.3;fill:url(#SVGID_11_);}\n\t.st25{fill:url(#SVGID_12_);}\n\t.st26{fill:url(#SVGID_13_);}\n\t.st27{opacity:0.4;fill:url(#SVGID_14_);}\n\t.st28{opacity:0.4;fill:url(#SVGID_15_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -13793.4062,
    y1: 43.8843,
    x2: -13638.165,
    y2: 136.1065,
    gradientTransform: "matrix(-1 0 0 1 -13558.666 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CD1641"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2097,
    style: {
      stopColor: "#C81C47",
      stopOpacity: 0.9645
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CD1641",
      stopOpacity: 0
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.578,68.447l115.211,158.269l119.476-130.3l-0.056-0.098c5.091-3.242,8.213-9.788,8.213-18.964 c0-19.084-13.479-42.337-30.109-51.935c-8.382-4.838-15.969-5.288-21.425-2.088l-0.056-0.098L2.578,68.447"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8633 -0.5047 0.5047 0.8633 -0.0102 117.0143)",
    className: "st1",
    cx: 216.002,
    cy: 58.526,
    rx: 22.497,
    ry: 38.967
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8633 -0.5047 0.5047 0.8633 -0.0102 117.0143)",
    className: "st1",
    cx: 216.002,
    cy: 58.526,
    rx: 7.863,
    ry: 13.62
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 137.753,
    cy: 97.297,
    r: 3.812
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 152.943,
    cy: 105.633,
    r: 3.812
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 166.269,
    cy: 87.771,
    r: 3.812
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 173.452,
    cy: 69.809,
    r: 3.812
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 183.958,
    cy: 83.547,
    r: 3.812
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 117.522,
    cy: 55.648,
    r: 2.447
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 123.192,
    cy: 79.67,
    r: 2.447
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 96.136,
    cy: 74.327,
    r: 2.447
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 70.472,
    cy: 101.896,
    r: 2.447
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 93.331,
    cy: 98.194,
    r: 2.447
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 139.384,
    cy: 54.185,
    r: 2.447
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 177.531,
    cy: 32.058,
    r: 2.447
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 177.214,
    cy: 104.421,
    r: 2.447
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 186.819,
    cy: 128.361,
    r: 2.447
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 147.6,
    cy: 130.016,
    r: 2.447
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 177.97,
    cy: 148.481,
    r: 2.447
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 162.197,
    cy: 147.443,
    r: 2.447
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 160.615,
    cy: 163.552,
    r: 2.447
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 132.826,
    cy: 172.042,
    r: 2.447
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 184.741,
    cy: 155.816,
    r: 2.447
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 138.948,
    cy: 113.415,
    r: 3.812
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 112.919,
    cy: 112.799,
    r: 3.812
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 119.674,
    cy: 121.888,
    r: 2.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 66.697,
    cy: 129.852,
    r: 2.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 155.6,
    cy: 93.414,
    r: 2.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 188.358,
    cy: 93.35,
    r: 2.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 115.784,
    cy: 138.477,
    r: 3.812
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 94.118,
    cy: 155.38,
    r: 3.812
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8633 -0.5047 0.5047 0.8633 -26.2252 91.0999)",
    className: "st4",
    cx: 155.057,
    cy: 93.961,
    rx: 35.62,
    ry: 61.699
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8633 -0.5047 0.5047 0.8633 -58.7632 60.3511)",
    className: "st5",
    cx: 82.026,
    cy: 138.652,
    rx: 49.206,
    ry: 85.23
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.ad1a17a21770da59f6b03580244094c4.svg";
export { ForwardRef as ReactComponent };